var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SalaryAdvanceInput',{attrs:{"customer":_vm.customer,"topup":_vm.instrument.id,"transfer":_vm.transfer,"arrears":_vm.instrument.arrears}})
}
var staticRenderFns = []

export { render, staticRenderFns }